<template>
  <div class="content">
    <auditLoggingSearch></auditLoggingSearch>
    <controllbar
      :dispItems="auditLoggings"
      @input-event="setAuditLogging"
      @list-reload="reload"
    >
    </controllbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="data_time_label">
              {{ dataTimeLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="data_source_label">
              {{ dataSourceLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="level_label">
              {{ levelLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="object_source_label">
              {{ objectSourceLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="event_id_label">
              {{ eventIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="detail_info_label">
              {{ detailLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispAuditLogging in auditLoggings"
            :key="dispAuditLogging.index"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispAuditLogging.checked"
                @click="checkedAction(dispAuditLogging)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <label class="data_time cell">
                {{ dispAuditLogging.dataTime }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <label class="data_source cell">
                {{ dispAuditLogging.dataSource }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <label class="level cell">
                {{ dispAuditLogging.level }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <label class="object_source cell">
                {{ dispAuditLogging.objectSource }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <label class="event_id cell">
                {{ dispAuditLogging.eventId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAuditLogging)">
              <div class="detail cell">
                {{ dispAuditLogging.detail }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setAuditLogging(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controllbar from './controllbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import auditLoggingSearch from './auditLoggingSearch.vue'

export default {
  data() {
    return {
      dataTimeLabel: '発生日時',
      dataSourceLabel: '発生箇所',
      levelLabel: 'レベル',
      objectSourceLabel: 'メインID',
      eventIdLabel: 'イベントID',
      detailLabel: '補足情報',
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    auditLoggings() {
      return this.$store.state.auditLoggings.auditLoggings
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.auditLoggings.total
      ) {
        return this.$store.state.auditLoggings.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.auditLoggings.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.auditLoggings.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 193
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('auditLoggings/clearSelectedLogList')
    let dateNow = new Date()
    const startDate = new Date(dateNow.getTime())
    startDate.setDate(dateNow.getDate() - 7)
    this.$store.dispatch('auditLoggings/searchStartDateTime', startDate)
    this.$store.dispatch('auditLoggings/searchEndDateTime', dateNow)
    this.$store.dispatch('auditLoggings/searchvalue', '')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setAuditLogging(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controllbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow,
    auditLoggingSearch
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.auditLoggings.length; i++) {
        this.auditLoggings[i].checked = this.checked
      }
      this.$store.dispatch(
        'auditLoggings/updateSelectedLogList',
        this.auditLoggings
      )
    },
    checkedAction(log) {
      log.checked = !log.checked
      this.$store.dispatch('auditLoggings/updateSelectedLogList', [log])
    },
    close(e) {
      this.showFalseModal = false
    },
    async reload() {
      this.$store.dispatch('auditLoggings/clearSelectedLogList')
      await this.setAuditLogging(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setAuditLogging(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      this.$store.dispatch('auditLoggings/changeFindAuditLoggings', [])
      let endDateTime = this.$store.state.auditLoggings.searchEndDateTime
      let startDateTime = this.$store.state.auditLoggings.searchStartDateTime
      // 空チェック
      if (startDateTime === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0202'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0202.name +
          this.errorMsg.MSGCRC0202.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      if (endDateTime === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0203'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0203.name +
          this.errorMsg.MSGCRC0203.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      startDateTime = startDateTime.getTime()
      endDateTime = endDateTime.getTime()
      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0200'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0200.name +
          this.errorMsg.MSGCRC0200.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      let eventNumber = this.$store.state.error.errorCode.errorCode_320001
      try {
        searchWord =
          searchWord === null
            ? this.$store.state.prevSearchWord
            : this.$store.state.auditLoggings.searchvalue === null
            ? ''
            : this.$store.state.auditLoggings.searchvalue
        await this.$store.dispatch('auditLoggings/setAuditLoggings', {
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
        let message = this.$store.state.auditLoggings.message.split(',')
        if (message[0] === 'MSGCRC0199') {
          this.falseWord =
            this.errorMsg.MSGCRC0199.name +
            this.errorMsg.MSGCRC0199.beforeValue +
            (Number(message[1]) + 1) +
            this.errorMsg.MSGCRC0199.middleValue +
            message[1] +
            this.errorMsg.MSGCRC0199.afterValue +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
        }
      } catch (error) {
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message.split(',')
          if (errorMessage[0]) {
            this.falseWord =
              this.errorMsg.MSGCRC0075.name +
              this.errorMsg.MSGCRC0075.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            errorMessage[0] = 'MSGCRC0075'
          }
          reason = errorMessage[0] + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.content {
  width: calc(100% - 262px);
}
td {
  width: 10%;
}
.cell {
  overflow: auto;
  word-break: break-all;
}
td:nth-child(2) {
  width: 20%;
}
td:nth-child(6) {
  width: 15%;
}
td:nth-child(7) {
  width: auto;
}
.bottom {
  width: calc(100% - 262px);
}
.bottom >>> table tr td a img {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLoggings/auditLoggingsList.vue